import { useNavigate } from 'react-router';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { CreateTeamDto } from '../../../commonTypes/organization.types';
import { useTranslation } from '../../useTranslation';

const useHttpPostTeam = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();
    const { t } = useTranslation('newNotifications');

    const exec = (body: CreateTeamDto) => {
        const { exec, abort } = organizationApi.createTeam({
            body,
            onSuccess: res => {
                toastHandler.push('success', t('team.createTeamTitle'), t('team.createTeamMessage_Success'));
                navigate(`/teams/${res.body.teamId}`);
            },
            onError: _ => toastHandler.push('error', t('team.createTeamTitle'), t('team.createTeamMessage_Failed')),
        });
        exec();
        return abort;
    };
    return { exec };
};

export default useHttpPostTeam;
